export const setAppointmentDetails = (data) => {
  return {
    type: "SET_APPOINTMENT_DETAILS",
    payload: {
      data,
    },
  };
};

export const setCurrentAppointment = (data) => {
  return {
    type: "SET_CURRENT_APPOINTMENT_UUID",
    payload: {
      data,
    },
  };
};
